<template>
    <b-container>
        <b-row>
            <data-loading></data-loading>
        </b-row>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading'

    export default {
        name: 'auth-autologin',
        data () {
            return {}
        },
        components: {
            'data-loading': DataLoading
        },
        mounted () {
            this.axios.get('auth/autologin/' + this.$route.params['token'])
                .then(response => {
                    this.$auth.token(null, response.data['token'])

                    this.$router.push({name: 'Cabinet'})
                }).catch(() => {
                    // вывод ошибки
                })
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// AutoLogin.vue?4ee39382